import { LocaleAuth } from '../en/auth'

const auth: LocaleAuth = {
  heading: 'CHO thể thao, BỞI thể thao.',
  signIn: 'Đăng Nhập',
  forgotPass: 'Quên Mật Khẩu?',
  claimQuestion: 'Vừa tham gia một giải đấu?',
  claimAccount: 'Yêu Cầu Tài Khoản Của Bạn',
  claimAccountDesc:
    'Đã từng chơi trong một giải đấu hoặc liên đoàn? Bạn có thể đã có hồ sơ người chơi và xếp hạng DUPR.',
  noAccount: 'Không có tài khoản DUPR?',
  signUp: 'Đăng Ký',
  createAccount: 'Tạo Tài Khoản',
  createPassword: 'Tạo Mật Khẩu',
  passInstructLength: 'Phải dài ít nhất 6 ký tự',
  passInstructStructure: 'Phải chứa một hoặc nhiều số',
  forgotPassDesc: 'Nhập email đã đăng ký của bạn để nhận hướng dẫn cách đặt lại mật khẩu của bạn.',
  checkYourEmail: 'Kiểm Tra Email Của Bạn!',
  resetCodeSentGeneric: 'Nếu có tài khoản cho địa chỉ đó, chúng tôi đã gửi mã 4 chữ số.',
  verifyEmailDesc: 'Bạn vừa nhận được một mã để đặt lại mật khẩu qua email. Nhập mã 4 chữ số để tiếp tục.',
  verifyYourNumber: 'Xác Minh Số Điện Thoại Của Bạn',
  verifyPhoneNumberDesc: 'Một mã 4 chữ số đã được gửi đến số điện thoại của bạn - nhập vào đây để xác minh.',
  claimAccountHelpText: 'Gõ tên của bạn vào thanh tìm kiếm để bắt đầu tìm kiếm kết quả của bạn',
  notSeeYourself: 'Không thấy bản thân ở đây?',
  lastMatch: 'Trận Đấu Cuối Cùng',
  noMatchResult: 'Không có kết quả trận đấu.',
  accAlreadyTaken: 'Tài khoản này đã được sử dụng',
  accAlreadyTakenModal:
    'Nếu bạn tin rằng đó là bạn, và ai đó đã yêu cầu tài khoản của bạn, vui lòng liên hệ với đội ngũ hỗ trợ của chúng tôi',
  iAgreeToThe: 'Tôi đồng ý với',
  termsOfService: 'Điều khoản dịch vụ',
  privacyPolicy: 'Chính sách bảo mật',
  acceptTerms: 'Vui lòng chấp nhận Điều khoản dịch vụ để tiếp tục',
  cookiePolicy: 'Chính sách cookie',
}

export default auth
